import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IGroup } from '@/contracts/system-modules/groups/IGroup'

export class GetGroupsRoute extends GroupsRoute<null, IGroup[]> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/groups'
  }

  /** Без сервера групп нет */
  offline(): Promise<ApiResponse<IGroup[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
